// Copyright 2022, Imprivata, Inc.  All rights reserved.

export const minutesToMilliseconds = (minutes: number) => {
  return 1000 * 60 * minutes;
};
